import styled from 'styled-components';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';

export default styled.div`
  display: grid;
  cursor: pointer;
  padding: 1rem;

  && + && {
    border-top: 1px solid ${lightGrey2Color};
  }

  &:first-child {
    border-radius: 0.25rem 0.25rem 0 0;
  }
  &:last-child {
    border-radius: 0 0 0.25rem 0.25rem;
  }

  &:hover {
    background-color: ${lightGrey1Color};
    .details-link {
      text-decoration: underline;
    }
  }
`;
